"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _customProps = require("../../utils/customProps");

var _MuiGridListTileBar = _interopRequireDefault(require("./components/MuiGridListTileBar/MuiGridListTileBar"));

/* eslint-disable max-len */
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper
    },
    icon: {
      color: 'rgba(255, 255, 255, 0.54)'
    }
  };
});

var MuiGridList = function MuiGridList(_ref) {
  var cellHeight = _ref.cellHeight,
      content = _ref.content,
      cols = _ref.cols,
      spacing = _ref.spacing,
      rootClass = _ref.rootClass,
      width = _ref.width,
      height = _ref.height;
  var classes = useStyles();

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    width: +width,
    height: +height
  });

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.GridList, {
    cols: +cols,
    cellHeight: +cellHeight,
    className: styles.root,
    spacing: +spacing
  }, content.map(function (tile) {
    return /*#__PURE__*/_react.default.createElement(_core.GridListTile, {
      key: tile.image,
      cols: +tile.cols,
      rows: +tile.rows
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: tile.image,
      alt: tile.title
    }), tile.MuiGridListTileBar.length !== 0 ? /*#__PURE__*/_react.default.createElement(_MuiGridListTileBar.default, tile.MuiGridListTileBar[0]) : null);
  })));
};

var _default = MuiGridList;
exports.default = _default;
MuiGridList.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component. See CSS API below for more details.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: number | 'auto'
   * Number of px for one cell height.
   * You can set 'auto' if you want to let the children determine the height.
   */
  cellHeight: _propTypes.default.string,

  /**
   * mui prop: number
   * Number of columns.
   */
  cols: _propTypes.default.string,

  /**
   * mui prop: number
   * Number of px for the spacing between tiles.
   */
  spacing: _propTypes.default.string,

  /**
   * mui prop: number
   * Number of px for the spacing between tiles.
   */
  height: function height(props, propName, componentName) {
    return (0, _customProps.muiDimensionProp)(props, propName, componentName);
  },

  /**
   * mui prop: number
   * Number of px for the spacing between tiles.
   */
  width: function width(props, propName, componentName) {
    return (0, _customProps.muiDimensionProp)(props, propName, componentName);
  },

  /**
   * Content passed to render
   * components: MuiTitleData
   */
  content: function content(props, propName, componentName) {
    var components = ['MuiTitleData'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  }
};
MuiGridList.defaultProps = {
  rootClass: [],
  cellHeight: 180,
  cols: 2,
  spacing: 4,
  height: 500,
  width: 450,
  content: []
};